// extracted by mini-css-extract-plugin
module.exports = {"ad-slot":"organism3-m__ad-slot__1YdRk","widget-wrapper":"organism3-m__widget-wrapper__1ocY3","widget-iframe":"organism3-m__widget-iframe__2Ho75","base":"organism3-m__base__3md-9"};